import React from 'react';
import { useTranslation } from 'react-i18next';

import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useController } from 'pages/Meetings/hooks/useController';

import Text from 'components/atom/Text/styles';

import { Container } from './styles';

const CardNotice: React.FC = () => {
  const { t } = useTranslation();
  const { setTab } = useController();

  return (
    <Container onClick={() => setTab(1)}>
      <Text weight="bold">{t('meetings:list.invitationNotice')}</Text>

      <FontAwesomeIcon icon={faChevronRight} />
    </Container>
  );
};

export default CardNotice;
